import { z } from "zod";
/** Required inside hashable BusinessGraph (D-020). */
export const SchemaVersionSchema = z.string().regex(/^v\d+(\.\d+)*$/);
export const BUSINESS_GRAPH_SCHEMA_VERSION = "v1.0";
//# sourceMappingURL=schema-version.js.map